import { render } from "./Cameras.vue?vue&type=template&id=a4ff152c&scoped=true"
import script from "./Cameras.vue?vue&type=script&lang=js"
export * from "./Cameras.vue?vue&type=script&lang=js"

import "./Cameras.vue?vue&type=style&index=0&id=a4ff152c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ff152c"]])

export default __exports__